import { Interfaces } from "../_interfaces";
import Modal from "../_bootstrapModalExtensions";
import { RefreshTopPartial } from "../pages/processActionEdit";
import Classes from "../_classes";
import Types from '../_types';
import * as Url from "../Utils/UrlUtil";

const signOffButtonId = "sign-off-button";
const quickSignOffButtonId = "quick-sign-off-button";

export function Init() {
    InitSignOffButton();
    InitQuickSignOffButton();
}

function InitSignOffButton() {
    $(document).on('click', '#' + signOffButtonId, OnSignOffButtonClicked);

    function OnSignOffButtonClicked(event: JQuery.ClickEvent) {
        const $signOffButton = $(event.currentTarget);
        const filingId: number = $signOffButton.data('filingid');
        const processActionId: number = $signOffButton.data('processactionid');

        DisplayAvailableClerksForSigning(filingId, processActionId);

        function DisplayAvailableClerksForSigning(filingId: number, processActionId: number) {
            Modal.showBootstrapModalWithAjaxContent(getModalConfig());

            function getModalConfig(): Classes.BootstrapModalWithAjaxContentSettings {
                let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();
                const urlTemplate: string = window.ETDR_RD.appConfig["UrlTemplate.ListClerksByOfficeForSignOff"];
                const contentUrl: string = Url.createUrlFromTemplate(urlTemplate, { entityId: filingId })
                let callbackFunc: Types.BootstrapModalCallback = (response) => {
                    AfterFilingSignOff(response.selectedClerkName, response.filingState);
                    RefreshTopPartial(processActionId);
                };

                settings.title = 'Válasszon ügyintézőt';
                settings.contentUrl = contentUrl;
                settings.saveUrl = window.ETDR_RD.appConfig['UrlAction.FilingSignOff'];
                settings.onBeforeSubmit = onBeforeSubmit;
                settings.callback = callbackFunc;
                settings.enableUnobtrusiveValidation = false;
                settings.canSaveUsingEnterKey = false;
                settings.saveText = 'Mentés';

                return settings;

                function onBeforeSubmit() {
                    const fadoId: number = $signOffButton.data('fadoid');

                    $('.fado-id-input-for-signoff').val(fadoId);
                }
            }
        }
    }
}

function InitQuickSignOffButton() {
    $(document).on('click', '#' + quickSignOffButtonId, OnQuickSignOffButtonClicked);

    function OnQuickSignOffButtonClicked(event: JQuery.ClickEvent) {
        const $quickSignoffBtn = $(event.currentTarget);

        const fadoId: number = $quickSignoffBtn.data('fadoid');
        const clerkId: number = $quickSignoffBtn.data('clerkid');
        const processActionId: number = $quickSignoffBtn.data('processactionid');

        $quickSignoffBtn.prop('disabled', true);

        SignOff(fadoId, clerkId)
            .done((response: Interfaces.JsonResponseForSignOff) => {
                if (response.success) {
                    AfterFilingSignOff(response.selectedClerkName, response.filingState);
                    RefreshTopPartial(processActionId);
                }
                else {
                    Modal.showAlertWindow(response.message || "Hiba!", "Hiba!");
                }
            })
            .always(() => {
                $quickSignoffBtn.prop('disabled', false);
            });

        function SignOff(fadoId: number, selectedClerkId: number): JQuery.Promise<any> {
            return $.ajax({
                method: 'POST',
                url: window.ETDR_RD.appConfig['UrlAction.FilingSignOff'],
                data: {
                    'fadoId': fadoId,
                    'selectedClerkId': selectedClerkId
                },
                headers: { Accept: 'application/json' }
            });
        }
    }
}

function AfterFilingSignOff(clerkName: string, filingState: string) {
    $('#signed-clerk-display-name-cell').text(clerkName);

    if (filingState) {
        $('#fado-state-cell').text(filingState);
    }
}
